import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Highlights from "./components/Highlights";
import Stats from "./components/Stats";
import Sobre from "./components/Sobre";
import Metodologia from "./components/Metodologia";
import Categorias from "./components/Categorias";
import Espaco from "./components/Espaco";
import Profissionais from "./components/Profissionais";
import Eventos from "./components/Eventos";
import Contato from "./components/Contato";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="bg-night font-body text-white">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Highlights />
        <Stats />
        <Sobre />
        <Metodologia />
        <Categorias />
        <Espaco />
        <Profissionais />
        <Eventos />
        <Contato />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
